import { I18nFragment, ResponsiveDialog } from '@diagentech/exprworks-ui-components';
import Box from '@mui/material/Box';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useCallback, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/App/hooks';
import { theme } from '@/App/theme';
import { DefaultFormButton } from '@/components/common/DefaultFormButton';
import { PrivacyPolicyContent } from '@/components/privacyPolicy/PrivacyPolicyContent';
import { selectUiState } from '@/features/ui/selectUiState';
import { setShowPrivacyPolicy } from '@/features/ui/uiSlice';

export const PRIVACY_POLICY_DIALOG_ID = 'privacy-policy-dialog';

export const PrivacyPolicyDialog: React.FC = () => {
  const [visible, setVisible] = React.useState(false);

  const dispatch = useAppDispatch();
  const { showPrivacyPolicy: open } = useAppSelector(selectUiState);

  useEffect(() => {
    if (open) {
      setVisible(true);
    }
  }, [open]);

  const onClose = useCallback(() => {
    dispatch(setShowPrivacyPolicy(false));
  }, [dispatch]);

  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <ResponsiveDialog
      id={PRIVACY_POLICY_DIALOG_ID}
      theme={theme}
      breakpoints={{ maxWidth: 'lg' }}
      fullWidth
      open={open}
      aria-labelledby="privacy-policy-dialog-title"
      onClose={onClose}
      {...(!visible ? { sx: { display: 'none' } } : {})}
    >
      <DialogTitle id="privacy-policy-dialog-title" component="h5">
        <Box
          {...(!matches
            ? {
                sx: {
                  fontSize: '1.15rem',
                },
              }
            : {})}
        >
          <I18nFragment id="SH.PG.PRIVACYPOLICY" />
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent
        style={{
          minHeight: '70vh',
          padding: '0 16px',
        }}
      >
        <PrivacyPolicyContent />
      </DialogContent>
      <DialogActions>
        <DefaultFormButton id="SH.BTN.CLOSE" color="primary" onClick={onClose} />
      </DialogActions>
    </ResponsiveDialog>
  );
};
